import styles from "./progress.module.less"
import { Card, ComponentState, Group, Skeleton, Text, Title } from "../index"
import { Col, Row } from "antd"
import Flex from "../flex"

const ProgressFormDetail = ({ mainTitle, subTitle, topRightItem, children, error, onErrorRetry, loading }) => {
  return (
    <Col span={17} className={styles}>
      <Card
        title={
          loading ? (
            <Flex gap={2} align="start" vertical>
              <Skeleton height={16} width={140} />
              <Skeleton height={14} width={160} />
            </Flex>
          ) : (
            <>
              <Title level={4} className="mbe-0">
                <span className="fw-medium">{mainTitle}</span>
              </Title>
              <Text type="secondaryLight" className="fs12">
                {subTitle}
              </Text>
            </>
          )
        }
        bordered={false}
        styles={{ body: { height: "calc(100vh - 250px)", overflowY: "auto" } }}
        extra={topRightItem}
      >
        {loading ? (
          <Group gap="20px">
            {[...Array(5)].map((_, index) => (
              <Row gutter={72}>
                <Col>
                  <Skeleton height={20} width={150} />
                </Col>
                <Col>
                  <Skeleton height={40} width={600} />
                </Col>
              </Row>
            ))}
          </Group>
        ) : error ? (
          <ComponentState status={error?.status} btnLoading={loading} onClick={() => onErrorRetry?.()} />
        ) : (
          children
        )}
      </Card>
    </Col>
  )
}

export default ProgressFormDetail
